<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:01:51
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-26 22:14:22
 * @Description: 主页面
 -->
<template>
  <div class="page__home" >
    <page-header id="a"></page-header>
    <tab-bar></tab-bar>
    <router-view />
    <page-footer></page-footer>
  </div>
</template>

<script>
import PageHeader from '@/components/page-header'
import PageFooter from '@/components/page-footer'
import TabBar from './tab-bar'

export default {
  components: {
    PageHeader,
    TabBar,
    PageFooter,
  },
}
</script>

<style lang="scss" scoped>
.page__home {
  width: 750px;
  margin: auto;
  padding-bottom: 48px;
}
.page__navi { // 回头删除
  position: fixed;
  margin-left: 200px;
  background: gray;
  z-index: 9;
  a {
    margin: 5px;
  }
}
</style>
